import { countryList } from '@/common/constants/country-list';
import { IAddress } from '@/common/types/general';
import { safeParsePhoneNumber } from './phone';

const formatValueByChunks = (value?: string) => {
  if (!value) {
    return '';
  }

  const chunks = value.match(/\d{1,3}/g);
  return chunks?.join(' ') ?? '';
};

const buildAddressString = ({
  addressLine1,
  addressLine2,
  zipCode,
  city,
  country,
}: IAddress) =>
  `${[addressLine1, addressLine2 || ''].join(' ')} - ${zipCode} ${city}, ${
    countryList.find((c) => c.iso2 === country)?.name ?? country
  }`;

const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return '';
  }

  const phoneObject = safeParsePhoneNumber(phoneNumber);
  return `${
    phoneObject?.countryCallingCode
      ? `+${phoneObject?.countryCallingCode as string}`
      : ''
  } ${formatValueByChunks((phoneObject?.nationalNumber as string) ?? '')}`;
};

const replaceStringIndex = (
  originalString: string,
  index: number,
  replacement: string
) => {
  return (
    originalString.slice(0, index) +
    replacement +
    originalString.slice(index + replacement.length)
  );
};

const getFirstLastName = (name: string) => {
  const names = name.split(' ');
  return `${names[0]} ${names.length > 1 ? names[names.length - 1] : ''}`;
};

const getFirstName = (name: string) => {
  const names = name.split(' ');
  return names[0];
};

const formatToSlug = (value: string) =>
  value
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');

const normalizeString = (text: string) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const formatPercentage = (text: string) => `${text}%`;

const truncateString = (text: string, maxLength: number) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
};

export const StringUtils = {
  formatValueByChunks,
  formatPhoneNumber,
  buildAddressString,
  replaceStringIndex,
  formatToSlug,
  getFirstLastName,
  normalizeString,
  formatPercentage,
  truncateString,
  getFirstName,
};
